module.exports = __webpack_public_path__ + "img/CG1_56.b3ea713.png";